import { Component, Input, OnInit } from '@angular/core';
import { MenuItemShared } from '../../../models/interface/menuItem.interface';
import { MuFieldPositionEnum } from '../../../models/interface/muFieldPosition.enum';
import { Actions } from '../../../types/actions.type';

@Component({
  selector: 'app-mu-popup-menu',
  templateUrl: './mu-popup-menu.component.html',
  styleUrls: ['./mu-popup-menu.component.sass'],
})
export class MuPopupMenuComponent<ActionType> implements OnInit {
  @Input() menuList: MenuItemShared[];
  @Input() actionList: Actions<ActionType, any>;
  @Input() position: MuFieldPositionEnum;

  constructor() {
    /** */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    /** */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */
}
